import React from 'react';
import './index.css';

const PageLoader = () => {
  return <div className="page-loader" />;
};

export default PageLoader;
